import { Injectable } from '@angular/core';
import {AuthUser} from '../models/auth-user.interface';

const USER = 'weee-kf-auth-user';

@Injectable({
  providedIn: 'root'
})
export class StorageService {

  constructor() {
  }

  clearInfo(): void {
    window.sessionStorage.clear();
  }

  public getUser(): AuthUser {
    const user = window.sessionStorage.getItem(USER);
    if (user) {
      return JSON.parse(user);
    } else {
      throw new Error('User not found');
    }
  }

  public saveUserAuth(user: AuthUser): void {
    window.sessionStorage.removeItem(USER);
    window.sessionStorage.setItem(USER, JSON.stringify(user));
  }

  public updateToken(token: string, refreshToken: string): void {
    const user = {...this.getUser(), token, refreshToken};
    this.saveUserAuth(user);
  }

  public getToken(): string {
    const user = this.getUser();
    return user.token;
  }

  public userExists(): boolean {
    const user = window.sessionStorage.getItem(USER);
    return user !== null;
  }

}
